import { isBrowser, isChrome, isDesktop, isEdge } from 'react-device-detect';
import { logger } from '@cutwise/utils';
import { eyeTracking } from '@/common/services/eye-tracking';
export function isRemotePresentationAvailable() {
    // PresentationRequest is browser API and available only with `https`
    return isDesktop && (isChrome || isEdge) && isBrowser && typeof window.PresentationRequest !== 'undefined';
}
export function isDetectScreenInfoAvailable() {
    // `getScreenDetails` is available in `window` only in `https` mode,
    return 'getScreenDetails' in window;
}
export async function availableScreens() {
    try {
        if (isDetectScreenInfoAvailable() && window.screen.isExtended) {
            const { state } = await navigator.permissions.query({
                name: 'window-management',
            });
            if (state !== 'denied') {
                return await window.getScreenDetails();
            }
            throw new Error('"window-management" denied');
        }
    }
    catch (e) {
        logger.error(e.message, e);
    }
    return {};
}
export async function isSecondMonitorAvailable() {
    try {
        const screens = await availableScreens();
        if (!screens?.screens || screens.screens.length <= 1) {
            alert('You need to have at least two monitors to start presentation!');
            return false;
        }
        return (
        // Presentation API works only for two monitors
        screens?.screens && screens.screens.length > 1);
    }
    catch (e) {
        alert('In order to start presentation, you should grant permission for "Window management" in Chrome Settings!');
        throw new Error(e);
    }
}
export function isStereoPresentationAvailable(args = {}) {
    try {
        /*
         * If we want to use Presentation API, make additional checks that this technology is available
         * */
        if (args.detectPresentationAPI) {
            /*
             * When API to detect two screens is not available, because it is experimental technology and only available under HTTPS:
             * https://developer.mozilla.org/en-US/docs/Web/API/Window/getScreenDetails
             * */
            if (!isDetectScreenInfoAvailable()) {
                logger.error('"isDetectScreenInfoAvailable()" returns false');
                return false;
            }
            if (!isRemotePresentationAvailable()) {
                logger.error('"isRemotePresentationAvailable()" returns false');
                return false;
            }
        }
        /*
         * "isExtended" will be false, when monitors are not extended (duplicated or selected only one to show)
         * */
        if (!window.screen.isExtended) {
            logger.error('"window.screen.isExtended" returns false');
            return false;
        }
        if (args.detectEyeTracking && eyeTracking.state !== 'started') {
            logger.error('Eye tracking extensions is not available!');
            return false;
        }
        return true;
    }
    catch (e) {
        return false;
    }
}
